import UpdateAccount from "../../../components/@account/UpdateAccount"

import { routeTypes } from "../../../hooks/useSystemRoutes"

export default function AccountPage() {

    return (
        <UpdateAccount 
            routeType={routeTypes.admin}
        />
    )
}